{
  "error": "Fel",
  "help": "Hjälp",
  "info": "Information",
  "success": "Lyckades",
  "warning": "Varning"
}
